
<template>
  <div>
    <v-dialog width="90%" v-model="dialog" persistent>
      <dialog-loading v-if="all_loadings"></dialog-loading>
      <v-card v-if="!all_loadings">
        <v-card-title>
          {{title}}
          <v-spacer></v-spacer>
          <BtnCreateDataExport 
            class="mx-3"
            api_model="ClientPortfolio" 
            action="ClientPortfolios"
            small
            light-toolbar
            :filters="{id: $route.params.id}"
            :file_name="$route.params.portfolio_name"
          ></BtnCreateDataExport>
        </v-card-title>
        <v-card-text style="overflow-y: auto; max-height:75vh">
          <div class="d-flex align-center">
            <v-text-field v-model="search" label="Pesquisar" prepend-icon="mdi-magnify"></v-text-field>
            <v-tooltip top>
              <template v-slot:activator="{on, attrs}">
                <v-btn color="primary" class="ml-5" small v-bind="attrs" v-on="on" @click="goToEdit()" v-if="canEditClientPortfolio">
                  <v-icon left small>mdi-pencil</v-icon>
                  Editar
                </v-btn>
              </template>
              <span>Editar Carteira de Clientes</span>
            </v-tooltip>
          </div>
          <v-data-table :items="data" :search="search" :headers="computed_headers">
            <template v-slot:item.attributes.name="{item}">
              <span>{{item.attributes.name}}</span>
              <span v-if="item.attributes.fantasyName && item.attributes.fantasyName != item.attributes.name">
                ({{item.attributes.fantasyName}})
              </span>
            </template>
            <template v-slot:item.attributes.last_purchase_at="{item}">
              {{ item.attributes.last_purchase_at ? $moment().diff($moment(item.attributes.last_purchase_at), 'days') : '-' }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" small @click="$router.push({name:'ClientPortfolios'})">Voltar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'DialogShowClientsAndEmployees',
  components: {
    BtnCreateDataExport: () => import('@/components/data_export/BtnCreateDataExport.vue'),
  },
  data() {
    return {
      headers:[
        { text: 'ID', value: 'id', align: 'center' },
        { text: 'Nome', value: 'attributes.name', align: 'center' },
      ],
      dialog: true,
      search:"",
      data:[],
      loading:{
        data: false,
      },
    }
  },
  computed: { 
    canEditClientPortfolio(){
      return this.isDirector() || this.isSalesExecutive()
    },
    title(){
      if(this.is_clients){
        return "Clientes da Carteira"
      }else{
        return "Funcionários da Carteira"
      }
    },
    computed_headers(){
      if(this.is_clients){
        let client_headers = [
          ...this.headers,
          { text: 'Cidade', value: 'attributes.city', align: 'center' },
        ]
        if(this.has_last_purchase){
          client_headers.push({ text: 'Última compra', value: 'attributes.last_purchase_at', align: 'center' })
        }
        return client_headers
      }else{
        return [
          ...this.headers,
          { text: 'CPF', value: 'attributes.cpf', align: 'center' },
          { text: 'Cargos', value: 'attributes.roles_translated', align: 'center' },
        ]
      }
    },
    is_clients(){
      return this.$route.params.kind == "clients"
    },
    // A API só envia last_purchase_at quando a carteira é de atividade
    has_last_purchase(){
      return this.data.some(item => item?.attributes && 'last_purchase_at' in item.attributes)
    },
    all_loadings(){
      return this.loading.data
    },
  },
  methods: {
    getData() {
      if(this.is_clients){
        this.getClients()
      }else{
        this.getEmployees()
      }
    },
    goToEdit(){
      let params = {id: this.$route.params.id}
      if(this.is_clients){
        params.edit_clients = true
      }else{
        params.edit_employees = true
      }
      this.$router.push({name: 'ShowClientPortifolio', params})
    },
    getClients(){
      this.loading.data = true
      let params = { 
        client_portfolio_id: this.$route.params.id,
        short: true
      }
      Api.Client.index(params).then((res)=>{
        this.data = [...res.data?.data]
      }).catch(er => {
        
      }).finally(()=>{
        this.loading.data = false
      })
    },
    getEmployees(){
      this.loading.data = true
      let params = { client_portfolio_id: this.$route.params.id}
      
      Api.Employee.index(params).then((res)=>{
        this.data = [...res.data?.data]
      }).catch(er => {
        
      }).finally(()=>{
        this.loading.data = false
      })
    },
  },

  mounted() {
    this.getData()
  },
}
</script>